"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJson = void 0;
const _ = require("lodash");
const keysToCamelCase = (obj) => {
    if (!_.isArray(obj) && _.isObject(obj)) {
        const n = {};
        Object.keys(obj).forEach((key) => {
            const fk = key;
            n[_.camelCase(key)] = obj[fk];
        });
        return n;
    }
    else if (_.isArray(obj)) {
        return obj.map(val => keysToCamelCase(val));
    }
    return obj;
};
const parseJson = (data) => {
    if (!data) {
        return undefined;
    }
    return keysToCamelCase(JSON.parse(data));
};
exports.parseJson = parseJson;
//# sourceMappingURL=JsonUtils.js.map